import { Icon, Text } from '@nimbus-ds/components';
import { CheckCircleIcon } from '@nimbus-ds/icons';
import { AddressingConfigurationRuleResponseDto } from '@tiendanube/common';
import { Stack } from 'commons/components';
import useTranslationShipping from 'domains/Shipping/useTranslationShipping';
import RulesListSkeleton from './RulesListSkeleton';
import { ADDRESSING_RULES_TYPES } from '../../constants';
import { findRuleByType } from '../../utils';

interface RulesListProps {
  rules: AddressingConfigurationRuleResponseDto[];
}

function RulesList({ rules }: Readonly<RulesListProps>) {
  const t = useTranslationShipping('deliveryMethods.addressingConfigurationV2');

  const materializeRuleEnabled = findRuleByType(
    rules,
    ADDRESSING_RULES_TYPES.MATERIALIZE,
  )?.enabled;

  const priorityRuleEnabled = findRuleByType(
    rules,
    ADDRESSING_RULES_TYPES.CD_PRIORITY,
  )?.enabled;

  const appRule = findRuleByType(rules, ADDRESSING_RULES_TYPES.APP);
  const appRuleEnabled = appRule?.enabled;

  return (
    <Stack column align="flex-start">
      {appRuleEnabled && (
        <Stack align="flex-start" spacing="extra-tight" column>
          <Text>{t('info.appRule.title')}</Text>
          <Stack spacing="extra-tight">
            <Icon color="neutral-textHigh" source={<CheckCircleIcon />} />
            <Text color="neutral-textHigh" fontWeight="bold">
              {appRule.appName}
            </Text>
          </Stack>
        </Stack>
      )}
      <Stack align="flex-start" spacing="extra-tight" column>
        <Text>{t('info.principalRule')}</Text>
        <Stack spacing="extra-tight">
          <Icon color="neutral-textHigh" source={<CheckCircleIcon />} />
          <Text color="neutral-textHigh" fontWeight="bold">
            {t(
              `types.${
                materializeRuleEnabled ? 'materialize' : 'withoutMaterialize'
              }`,
            )}
          </Text>
        </Stack>
      </Stack>
      <Stack align="flex-start" spacing="extra-tight" column>
        <Text>
          {t(
            `info.secondaryRule.${
              materializeRuleEnabled ? 'withMaterialize' : 'withoutMaterialize'
            }`,
          )}
        </Text>
        <Stack spacing="extra-tight">
          <Icon color="neutral-textHigh" source={<CheckCircleIcon />} />
          <Text color="neutral-textHigh" fontWeight="bold">
            {priorityRuleEnabled
              ? t('types.cdPriority')
              : t('types.cdProximity')}
          </Text>
        </Stack>
      </Stack>
    </Stack>
  );
}

RulesList.Skeleton = RulesListSkeleton;
export default RulesList;
